import { SideBarDef } from 'ag-grid-community'

export const sideBarDef = (options: any = {}): SideBarDef => {
  const { labelDefault = 'Toutes les colonnes', ...rest } = options

  return {
    toolPanels: [
      {
        id: 'columns',
        labelDefault,
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
        toolPanelParams: {
          enableRowGroup: false,
          suppressRowGroups: true,
          suppressValues: true,
          suppressPivots: true,
          suppressPivotMode: true,
          suppressColumnSelectAll: true,
          suppressColumnExpandAll: true,
          contractColumnSelection: true,
          ...rest,
        },
      },
    ],
    position: 'right',
    hiddenByDefault: true,
  }
}
